import { apiHelper } from '@/util'
import {SHARED} from "@/constants/constants";

export const lottoService = {
    lottoDrawsCurrent,
    lottoDrawsResults,
    lottoWalletBalance,
    lottoWalletClaim,
    lottoLastDrawsHistory,
    lottoDrawsHistory,
    lottoProgress,
    lottoTickets,
    lottoMemberProgress,
    lottoTicketsHistory,
    lottoTicketSettings,
    lottoHistoryMatches,
    lottoLastDrawsResults,
    lottoPastMatches,
    lottoActivity
}

//API urls
const LOTTO = {
    LOTTO: 'lottery',
    DRAWS: 'draws',
    WALLET: 'wallet',
    CURRENT: 'current',
    RESULTS: 'results',
    BALANCE: 'balance',
    CLAIM: 'claim',
    HISTORY: 'history',
    PROGRESS: 'progress',
    TICKETS: 'tickets',
    MEMBER_PROGRESS: 'member-progress',
    TICKET_SETTINGS: 'ticket-settings',
    MATCHES: 'matches',
    ACTIVITY: 'activity'
}

function lottoDrawsCurrent() {
    return apiHelper().get(`/${LOTTO.LOTTO}/${LOTTO.DRAWS}/${LOTTO.CURRENT}`)
}

function lottoDrawsResults(id) {
    return apiHelper().get(`/${LOTTO.LOTTO}/${LOTTO.DRAWS}/${id}/${LOTTO.RESULTS}`)
}

function lottoWalletBalance() {
    return apiHelper().get(`/${LOTTO.LOTTO}/${LOTTO.WALLET}/${LOTTO.BALANCE}`)
}

function lottoWalletClaim() {
    return apiHelper().post(`/${LOTTO.LOTTO}/${LOTTO.WALLET}/${LOTTO.CLAIM}`)
}

function lottoLastDrawsHistory() {
    return apiHelper().get(`/${LOTTO.LOTTO}/${LOTTO.DRAWS}/${LOTTO.HISTORY}?per_page=1`)
}

function lottoDrawsHistory() {
    let requestOptions = {
        params: {
            per_page: 50,
            page: 1
        }
    }
    return apiHelper().get(`/${LOTTO.LOTTO}/${LOTTO.DRAWS}/${LOTTO.HISTORY}`, requestOptions)
}

function lottoProgress() {
    return apiHelper().get(`/${LOTTO.LOTTO}/${LOTTO.PROGRESS}`)
}

function lottoTickets(obj) {
    const requestOptions = {
        params: {
            draw_id: obj.id,
            page: obj.page,
            per_page: 10
        }
    }
    return apiHelper().get(`${LOTTO.LOTTO}/${LOTTO.TICKETS}`, requestOptions)
}

function lottoMemberProgress(obj) {
    const requestOptions = {
        params: {
            member_code: obj.member_code,
            type: obj.type
        }
    }
    return apiHelper().get(`${LOTTO.LOTTO}/${LOTTO.MEMBER_PROGRESS}`, requestOptions)
}

function lottoTicketsHistory(obj) {
    let requestOptions = {
        params: {
            draw_id: obj.id,
            page: obj.page,
            per_page: 20
        }
    }
    return apiHelper().get(`/${LOTTO.LOTTO}/${LOTTO.TICKETS}/${LOTTO.HISTORY}`, requestOptions)
}

function lottoTicketSettings() {
    return apiHelper().get(`/${LOTTO.LOTTO}/${LOTTO.TICKET_SETTINGS}`)
}

function lottoHistoryMatches(obj) {
    let requestOptions = {
        params: {
            draw_ids: obj.draw_ids
        }
    }
    return apiHelper().get(`/${LOTTO.LOTTO}/${LOTTO.DRAWS}/${LOTTO.HISTORY}/${LOTTO.MATCHES}`, requestOptions)
}

function lottoLastDrawsResults(id) {
    return apiHelper().get(`/${LOTTO.LOTTO}/${LOTTO.DRAWS}/${id}/${LOTTO.RESULTS}`)
}

function lottoPastMatches(obj) {
    let requestOptions = {
        params: {
            draw_ids: obj.draw_ids
        }
    }
    return apiHelper().get(`/${LOTTO.LOTTO}/${LOTTO.DRAWS}/${LOTTO.HISTORY}/${LOTTO.MATCHES}`, requestOptions)
}

function lottoActivity() {
    let requestOptions = {
        params: {
            limit: 100,
            window: 60
        }
    }
    return apiHelper().get(`/${LOTTO.LOTTO}/${LOTTO.ACTIVITY}`, requestOptions)
}